<script lang="ts">
    import Fa from 'svelte-fa'
    import { faPlus } from '@fortawesome/free-solid-svg-icons'
    import { Board } from '../../../modules/pipelineApi/pipeline/boards/board'
    import { BoardsRepository } from '../../../modules/pipelineApi/pipeline/boards/boards.repository'
    import { BoardsService } from '../../../modules/pipelineApi/pipeline/boards/boards.service'
    import Content from '../../_common/content.svelte'
    import BoardItem from './board-item.svelte'
    import { createEventDispatcher } from 'svelte'
    import Popover from '../../_common/popover.svelte'
    import ListIntegration from './list-integration.svelte'
    const dispatch = createEventDispatcher()

    const boardR: BoardsRepository = new BoardsRepository()
    const boardS: BoardsService = new BoardsService(boardR)
    let boards: Board[] = []
    let newBoard: boolean = false

    async function loadBoards() {
        boards = await boardS.getAll({ lists: true })
        console.log('boards', boards)
    }

    async function boardItemChange() {
        loadBoards()
        dispatch('change')
    }

    let emptyBoard: Board
    function newBoardItem() {
        emptyBoard = new Board()
        emptyBoard.label = ''
        emptyBoard.lists = []
        newBoard = true
    }

    function newBoardSuccess() {
        newBoard = false
        loadBoards()
        dispatch('change')
    }

    loadBoards()

    let linkList = null
    function onIntegration(ev) {
        linkList = ev.detail
    }
</script>

{#if linkList}
    <Popover on:close={() => (linkList = null)} width="880px" title="Link de integração externa">
        <ListIntegration list={linkList} />
    </Popover>
{/if}

<Content>
    <div class="root">
        {#each boards as board, i (board.boardId)}
            <BoardItem on:integration={onIntegration} on:change={boardItemChange} {board} />
        {/each}
        <div class="newBoard">
            {#if newBoard}
                <BoardItem on:integration={onIntegration} board={emptyBoard} on:change={newBoardSuccess} />
            {:else}
                <button class="btn btn-secondary btn-sm" on:click={newBoardItem}><Fa icon={faPlus} /> Novo pipeline</button>
            {/if}
        </div>
    </div>
</Content>

<style>
    .root {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        padding-bottom: 16px;
    }
    .newBoard {
        text-align: center;
        margin-top: 32px;
        margin-bottom: 64px;
    }
</style>
